import { AccordionHeader, AccordionItem, AccordionPanel, Button, Text } from '@fluentui/react-components';
import { DeleteRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { Organization } from '../../../models';
import { CompanyInformation } from './CompanyInformation';
import './JointNominee.scss';

interface JointNomineeProps {
  rowKey: string;
  jointNomineeIndex: number;
  onRemoveNominee: () => void;
  organization: Organization;
}

const JointNomineeImpl: React.FC<JointNomineeProps> = (props) => {
  const {
    rowKey,
    jointNomineeIndex,
    onRemoveNominee,
    organization,
  } = props;

  const {
    nominationWizardPageUiStore,
  } = useStores();

  const isBeingValidated = nominationWizardPageUiStore.isBeingValidated('joint-nominee');
  const validation = nominationWizardPageUiStore.jointNomineeValidations[jointNomineeIndex];

  return (
    <AccordionItem
      value={rowKey}
      className='joint-nominee'
    >
      <AccordionHeader
        expandIconPosition='end'
        className={`joint-nominee__header ${isBeingValidated && !validation.isValid ? 'red-bg' : 'blue-bg'}`}
      >
        <Text
          weight='semibold'
        >
          {organization.companyName ? `Joint Nominee - ${organization.companyName}` : 'Joint Nominee'}
        </Text>
      </AccordionHeader>
      <Button
        icon={<DeleteRegular />}
        title='Delete'
        onClick={onRemoveNominee}
        appearance='transparent'
      />
      <AccordionPanel
        className='joint-nominee__panel'
      >
        <CompanyInformation
          accounts={[]}
          organization={organization}
          jointNomineeRowKey={rowKey}
          displayMpnIdSelectionPreferance={false}
          validationErrors={validation.fieldErrors}
          displayRefreshFromPartnerCenter={false}
          displayOrganizationContactForm={true}
        />
      </AccordionPanel>
    </AccordionItem>
  );
};

export const JointNominee = observer(JointNomineeImpl);
